import React from 'react';
import styles from './Card.module.css';

interface CardProps {
  title: string;
  /** A string renders as a paragraph; an array renders as a bullet list */
  description: string | string[];
  image?: string;
  actionLabel?: string;
  action?: () => void;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, description, image, actionLabel, action, className = '' }) => {
  return (
    <div className={`${styles.card} ${className}`}>
      {image && (
        <div className={styles.cardImage}>
          <img src={image} alt={title} />
        </div>
      )}
      <div className={styles.cardContent}>
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>{title}</h3>
          {Array.isArray(description) ? (
            <ul className={`${styles.cardDescription} ${styles.cardDescriptionList}`}>
              {description.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          ) : (
            <p className={styles.cardDescription}>{description}</p>
          )}
        </div>
        {actionLabel && (
          <div className={styles.cardAction}>
            <button
              className={styles.cardButton}
              onClick={action}
            >
              <span>{actionLabel}</span>
              <i className='icon icon-arrow-right' />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
